import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { CampaignMessagesTab } from '../../components/CampaignMessagesTab';

const CampaignsMessages = () => {
  const navigate = useNavigate({ from: '/campaigns' });

  const openCampaign = (campaignId: string) =>
    navigate({ search: prev => ({ ...prev, campaignId }) });

  return <CampaignMessagesTab onOpenCampaign={openCampaign} />;
};

export const Route = createFileRoute('/campaigns/messages')({
  component: CampaignsMessages
});
